module.exports = __webpack_public_path__ + "static/media/icon_limitedTraining.568b38be.svg";